export default "__VITE_ASSET__YJefiHE___"